import { EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { appRenameFixed } from "../appRenameFixed";
var AbilityTestReportComponent = (function () {
    function AbilityTestReportComponent(router, apiService, commonService) {
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        this.onGoBackSurvey = new EventEmitter();
        this.appRename = new appRenameFixed();
    }
    AbilityTestReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        var that = this;
        this.card1Show = true;
        this.card2Show = true;
        this.detail1Show = false;
        this.detail2Show = false;
        if (this.learningPathId != 'not') {
            this.apiService.ajax({
                'type': 'get',
                'url': '/api/concatenation/' + this.learningPathId,
                'data': {
                    'learningPathId': this.learningPathId,
                }
            }).subscribe(function (comment) {
                comment.forEach(function (item, index) {
                    if (item.title == '能力诊断') {
                        that.chuanjie = item.comment;
                    }
                });
                /*this.chuanjie = comment[1].comment;*/
            });
            this.apiService.ajax({
                'type': 'get',
                'url': '/api/learningpathes/' + this.learningPathId
            }).subscribe(function (result) {
                _this.learningPath = result;
                _this.learningPath.subItems.forEach(function (item, index) {
                    if (item.type == 1) {
                        that.preSurveyId = item.id;
                    }
                    else if (item.type == 4) {
                        that.postSurveyId = item.id;
                    }
                });
                if (_this.preSurveyId == _this.surveyId) {
                    _this.mode = 1;
                    _this.apiService.getReport("" + _this.preSurveyId + "").subscribe(function (result) {
                        _this.preReport = result.details[0];
                        _this.reportName = _this.preReport.name;
                        _this.preLevel = _this.preReport.level;
                        _this.description = _this.preReport.description;
                        _this.development = _this.preReport.development;
                    });
                }
                else {
                    _this.mode = 2;
                    _this.apiService.getReport("" + _this.postSurveyId + "").subscribe(function (result) {
                        _this.postReport = result.details[0];
                        _this.reportName = _this.postReport.name;
                        _this.postLevel = _this.postReport.level;
                        _this.description = _this.postReport.description;
                        _this.development = _this.postReport.development;
                        _this.apiService.getReport("" + _this.preSurveyId + "").subscribe(function (result) {
                            _this.preReport = result.details[0];
                            _this.preLevel = _this.preReport.level;
                        });
                    });
                    if (_this.learningPath.name == "辅导") {
                        _this.apiService.ajax({
                            'type': 'get',
                            'url': '/sr/onceino/105',
                            'data': {}
                        }).subscribe(function (result) {
                            _this.finishStatus = result == 1 ? true : false;
                        });
                    }
                    else if (_this.learningPath.name == "打造高效团队") {
                        _this.apiService.ajax({
                            'type': 'get',
                            'url': '/sr/onceino/115',
                            'data': {}
                        }).subscribe(function (result) {
                            _this.finishStatus = result == 1 ? true : false;
                        });
                    }
                    else if (_this.learningPath.name == "授权") {
                        _this.apiService.ajax({
                            'type': 'get',
                            'url': '/sr/onceino/125',
                            'data': {}
                        }).subscribe(function (result) {
                            _this.finishStatus = result == 1 ? true : false;
                        });
                    }
                    else if (_this.learningPath.name == "计划与组织") {
                        _this.apiService.ajax({
                            'type': 'get',
                            'url': '/sr/onceino/145',
                            'data': {}
                        }).subscribe(function (result) {
                            _this.finishStatus = result == 1 ? true : false;
                        });
                    }
                    else if (_this.learningPath.name == "协作") {
                        _this.apiService.ajax({
                            'type': 'get',
                            'url': '/sr/onceino/155',
                            'data': {}
                        }).subscribe(function (result) {
                            _this.finishStatus = result == 1 ? true : false;
                        });
                    }
                    else if (_this.learningPath.name == "影响力") {
                        _this.apiService.ajax({
                            'type': 'get',
                            'url': '/sr/onceino/165',
                            'data': {}
                        }).subscribe(function (result) {
                            _this.finishStatus = result == 1 ? true : false;
                        });
                    }
                    else if (_this.learningPath.name == "决策") {
                        _this.apiService.ajax({
                            'type': 'get',
                            'url': '/sr/onceino/175',
                            'data': {}
                        }).subscribe(function (result) {
                            _this.finishStatus = result == 1 ? true : false;
                        });
                    }
                }
            });
        }
        else {
            if (this.surveyType == 2) {
                this.mode = 1;
                this.preReport = this.tourSingleReport;
                this.reportName = this.preReport.name;
                this.preLevel = this.preReport.level;
                this.description = this.preReport.description;
                this.development = this.preReport.development;
            }
            else if (this.surveyType == 3) {
                this.mode = 2;
                this.postReport = this.tourSingleReport;
                this.reportName = this.postReport.name;
                this.postLevel = this.postReport.level;
                this.description = this.postReport.description;
                this.development = this.postReport.development;
                this.preLevel = this.postReport.preLevel;
                this.preReport = this.postReport.preReport;
                //   this.apiService.getReport("" + (this.reportId - 1) + "").subscribe(result => {
                //     this.preReport = result.details[0];
                //     this.preLevel = this.preReport.level;
                // });
            }
        }
        /*this.learningPath = this.getMockData2();
        this.preReport = true;
        this.chuanjie = '文案文案文案';
        this.preLevel = 1;
        this.postLevel = 3;
        this.description = '文案文案文案';*/
    };
    AbilityTestReportComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    AbilityTestReportComponent.prototype.getCourse = function () {
        var _this = this;
        // if(this.learningPathId!='not'){
        //   let courseId = this.learningPath.subItems[2].id;
        //   let link = ['course', this.learningPath.id, courseId];
        //   this.router.navigate(link);
        // }else{
        //   let courseId = this.learningPath.subItems[1].id;
        //   let link = ['course', this.learningPath.id, courseId];
        //   this.router.navigate(link);
        // }
        var courseId, itemIndex;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 2) {
                courseId = item.id;
                itemIndex = index;
            }
        });
        this.apiService.ajax({
            'type': 'GET',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPath.id
        }).subscribe(function (result) {
            _this.learningPathMetaId = result.data;
            _this.apiService.ajax({
                'type': 'GET',
                'url': '/sr/exposeoutapi/setAbilitySession/' + _this.learningPathMetaId + '/2'
            }).subscribe(function (result) { });
        });
        var link = ['course', this.learningPath.id, courseId];
        this.router.navigate(link);
    };
    AbilityTestReportComponent.prototype.close = function () {
        var _this = this;
        if (!this.finishStatus) {
            if (this.learningPathId != 'not' && this.mode == 1) {
                this.apiService.ajax({
                    'type': 'get',
                    'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
                }).subscribe(function (result) {
                    var link = ['learning-path', result.data];
                    _this.router.navigate(link);
                });
            }
            else if (this.learningPathId != 'not' && this.mode == 2) {
                if (this.learningPath.name == "辅导") {
                    this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/105',
                        'data': {}
                    }).subscribe();
                }
                else if (this.learningPath.name == "打造高效团队") {
                    this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/115',
                        'data': {}
                    }).subscribe();
                }
                else if (this.learningPath.name == "授权") {
                    this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/125',
                        'data': {}
                    }).subscribe();
                }
                else if (this.learningPath.name == "计划与组织") {
                    this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/145',
                        'data': {}
                    }).subscribe();
                }
                else if (this.learningPath.name == "协作") {
                    this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/155',
                        'data': {}
                    }).subscribe();
                }
                else if (this.learningPath.name == "影响力") {
                    this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/165',
                        'data': {}
                    }).subscribe();
                }
                else if (this.learningPath.name == "决策") {
                    this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/175',
                        'data': {}
                    }).subscribe();
                }
                var link = ['learning-map'];
                this.router.navigate(link);
            }
            else if (this.learningPathId == 'not') {
                // let link = ['learning-map'];
                // this.router.navigate(link);
                this.onGoBackSurvey.emit();
            }
        }
        else {
            if (this.learningPathId != 'not') {
                var link = ['learning-map'];
                this.router.navigate(link);
            }
            else if (this.learningPathId == 'not') {
                // let link = ['learning-map'];
                // this.router.navigate(link);
                this.onGoBackSurvey.emit();
            }
        }
    };
    AbilityTestReportComponent.prototype.finish = function () {
        if (this.finishStatus || this.learningPathId == 'not') {
            return;
        }
        else {
            if (this.learningPath.name == "辅导") {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/105',
                    'data': {}
                }).subscribe();
            }
            else if (this.learningPath.name == "打造高效团队") {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/115',
                    'data': {}
                }).subscribe();
            }
            else if (this.learningPath.name == "授权") {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/125',
                    'data': {}
                }).subscribe();
            }
            else if (this.learningPath.name == "计划与组织") {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/145',
                    'data': {}
                }).subscribe();
            }
            else if (this.learningPath.name == "协作") {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/155',
                    'data': {}
                }).subscribe();
            }
            else if (this.learningPath.name == "影响力") {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/165',
                    'data': {}
                }).subscribe();
            }
            else if (this.learningPath.name == "决策") {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/sr/onceino/175',
                    'data': {}
                }).subscribe();
            }
            var link = ['learning-map'];
            this.router.navigate(link);
        }
    };
    AbilityTestReportComponent.prototype.detailClick1 = function () {
        this.card1Show = false;
        this.detail1Show = true;
        $('#shade').fadeIn(200);
        setTimeout(function () {
            $("#detailContent1").fadeIn(10);
        }, 200);
    };
    AbilityTestReportComponent.prototype.detailBtnClick1 = function () {
        this.detail1Show = false;
        this.card1Show = true;
        $('#shade').fadeOut(200);
        setTimeout(function () {
            $("#detailContent1").fadeOut(200);
        }, 50);
    };
    AbilityTestReportComponent.prototype.detailClick2 = function () {
        this.card2Show = false;
        this.detail2Show = true;
        $('#shade').fadeIn(200);
        setTimeout(function () {
            $("#detailContent2").fadeIn(10);
        }, 200);
    };
    AbilityTestReportComponent.prototype.detailBtnClick2 = function () {
        this.detail2Show = false;
        this.card2Show = true;
        $('#shade').fadeOut(200);
        setTimeout(function () {
            $("#detailContent2").fadeOut(200);
        }, 50);
    };
    return AbilityTestReportComponent;
}());
export { AbilityTestReportComponent };



// WEBPACK FOOTER //
// ./src/app/ability-test-report/ability-test-report.component.ts.pre-build-optimizer.js